var React = require('react');

function BbaTrouble (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 10.75V6h1.9v4.75H15zm0 3.8v-1.9h1.9v1.9H15zm-7.196 3.103H2V2.723h5.229q2.718 0 4.123 1.041 1.404 1.041 1.404 3.05 0 1.098-.564 1.933-.564.836-1.568 1.226 1.148.287 1.809 1.158.662.872.662 2.133 0 2.153-1.374 3.261-1.374 1.107-3.917 1.128zm.092-6.501h-2.82v4.03h2.635q1.087 0 1.697-.518.611-.518.611-1.431 0-2.05-2.123-2.081zm-2.82-5.937v3.763h2.277Q9.68 8.937 9.68 7.122q0-1.015-.589-1.461-.59-.446-1.862-.446H5.076z","fill":"currentColor"}));
}

BbaTrouble.defaultProps = {"viewBox":"0 0 18 20"};

module.exports = BbaTrouble;

BbaTrouble.default = BbaTrouble;
